import { isBinarySkillFileContent } from "@promptlayer/ui";

export enum MediaFileType {
  UNAVAILABLE = "unavailable",
  CSV = "csv",
  BINARY = "binary",
  TEXT = "text",
}

export const determineMediaFileType = ({
  showUnavailableMessage,
  previewPath,
  oldValue,
  newValue,
}: {
  showUnavailableMessage: boolean;
  previewPath: string;
  oldValue: string;
  newValue: string;
}): MediaFileType => {
  if (showUnavailableMessage) {
    return MediaFileType.UNAVAILABLE;
  }
  if (previewPath.toLowerCase().endsWith(".csv")) {
    return MediaFileType.CSV;
  }
  if (isBinarySkillFileContent(oldValue) || isBinarySkillFileContent(newValue)) {
    return MediaFileType.BINARY;
  }
  return MediaFileType.TEXT;
};
